/**
 * @generated SignedSource<<b457ff7e9f91b42284b0838a5ff16a83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type signup_viewer$data = {
  readonly actualPersonId: string | null;
  readonly downForMaintenance: boolean | null;
  readonly " $fragmentType": "signup_viewer";
};
export type signup_viewer$key = {
  readonly " $data"?: signup_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"signup_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "signup_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3104530ab4abc48f4cd52856b3827a78";

export default node;
